/**
 * Mission Focus Areas — Frontend tab switching with ARIA keyboard navigation.
 */
(function () {
	'use strict';

	function initFocusAreas(container) {
		const tablist = container.querySelector('[role="tablist"]');
		if (!tablist) return; // Single tab — no switching needed

		const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
		const panels = Array.from(container.querySelectorAll('[role="tabpanel"]'));

		if (tabs.length === 0 || panels.length === 0) return;

		function activateTab(tab) {
			// Deactivate all
			tabs.forEach(function (t) {
				t.setAttribute('aria-selected', 'false');
				t.setAttribute('tabindex', '-1');
				t.classList.remove('mission-focus-areas__tab--active');
			});

			panels.forEach(function (p) {
				p.classList.remove('mission-focus-areas__panel--active');
				p.setAttribute('hidden', '');
			});

			// Activate selected
			tab.setAttribute('aria-selected', 'true');
			tab.setAttribute('tabindex', '0');
			tab.classList.add('mission-focus-areas__tab--active');
			tab.focus();

			var panelId = tab.getAttribute('aria-controls');
			var panel = container.querySelector('#' + panelId);
			if (panel) {
				panel.classList.add('mission-focus-areas__panel--active');
				panel.removeAttribute('hidden');
			}
		}

		// Click handlers
		tabs.forEach(function (tab) {
			tab.addEventListener('click', function () {
				activateTab(tab);
			});
		});

		// Keyboard navigation
		tablist.addEventListener('keydown', function (e) {
			var currentIndex = tabs.indexOf(document.activeElement);
			if (currentIndex === -1) return;

			var newIndex;

			switch (e.key) {
				case 'ArrowRight':
				case 'ArrowDown':
					e.preventDefault();
					newIndex = (currentIndex + 1) % tabs.length;
					activateTab(tabs[newIndex]);
					break;

				case 'ArrowLeft':
				case 'ArrowUp':
					e.preventDefault();
					newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
					activateTab(tabs[newIndex]);
					break;

				case 'Home':
					e.preventDefault();
					activateTab(tabs[0]);
					break;

				case 'End':
					e.preventDefault();
					activateTab(tabs[tabs.length - 1]);
					break;
			}
		});
	}

	function init() {
		var containers = document.querySelectorAll('[data-focus-areas]');
		containers.forEach(initFocusAreas);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
